function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import applyReducer, { reduceReducers } from './applyReducer';
import cabinetConstants from '../constants/cabinetConstants';
import entityReducerFactory from './factories/entityReducerFactory';
import formConstants from '../constants/formConstants';
const entityReducer = entityReducerFactory('cabinet');
const initState = {
  initialIndexQuery: _objectSpread(_objectSpread({}, entityReducer.initState.initialIndexQuery), {}, {
    sortDirection: null // avoid specifying server-side column sorting by default
  }),
  selectedView: {}
};

/**
 *  Set cabinet-specific loading and clear updatedFormType when the index call is made
 */
const index = state => {
  const {
    currentCabinet
  } = state;
  const cabinetState = _objectSpread(_objectSpread({}, state), {}, {
    updatedFormType: null,
    [currentCabinet]: _objectSpread(_objectSpread({}, state[currentCabinet]), {}, {
      loading: true,
      totalCount: null
    })
  });
  return cabinetState;
};

/**
 *  Store index data in cabinet-specific data objects to allow multiple simultaneous cabinets
 * without reloading
 */
const indexSuccess = state => {
  const {
    currentCabinet,
    initialIndexQuery
  } = state;
  const cabinetState = _objectSpread({}, state);
  const currentCabinetState = {};
  const entityResponseProps = Object.keys(entityReducer.initState);
  entityResponseProps.forEach(prop => {
    // only add entity state to the cabinet-specific property
    currentCabinetState[prop] = state[prop];

    // remove cabinet-specific entity state from top level
    delete cabinetState[prop];
  });

  // set the cabinet-specific state to the top-level
  cabinetState[currentCabinet] = currentCabinetState;
  cabinetState.initialIndexQuery = initialIndexQuery; // reset after clearing

  return cabinetState;
};
const select = (state, action) => {
  const {
    currentCabinet
  } = state;
  const selected = state[currentCabinet].selected || [];
  selected.push(action.id);
  return state;
};
const selectClear = (state, action) => {
  const {
    currentCabinet
  } = state;
  const selected = state[currentCabinet].selected || [];
  if (selected.includes(action.id)) {
    selected.splice(selected.indexOf(action.id), 1);
  }
  return state;
};
const selectAll = (state, action) => {
  const {
    currentCabinet
  } = state;
  const selected = state[currentCabinet].selected || [];
  selected.push(...action.selected);
  return state;
};
const selectClearAll = state => {
  const {
    currentCabinet
  } = state;

  // eslint-disable-next-line no-param-reassign
  state[currentCabinet].selected = [];
  return state;
};
const setCurrent = (state, {
  currentCabinet
}) => _objectSpread(_objectSpread({}, state), {}, {
  currentCabinet
});

/**
 *  When a form is saved the index view should be reloaded. Trigger this by passing
 *  the updated formType back to the cabinet
 */
const saveSuccess = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  updatedFormType: action.data.formType.identifier
});
const setSelectedView = (state, action) => {
  const {
    cabinetIdentifier,
    selectedView
  } = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedView: _objectSpread(_objectSpread({}, state.selectedView), {}, {
      [cabinetIdentifier]: selectedView || 'List'
    })
  });
};
const setAiRequest = (state, action) => {
  const {
    cabinetIdentifier
  } = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      aiRequest: true,
      aiSuccess: false,
      aiError: null
    })
  });
};
const setAiSuccess = (state, action) => {
  const {
    cabinetIdentifier
  } = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      aiRequest: false,
      aiSuccess: true,
      aiError: null
    })
  });
};
const indexCountSuccess = (state, action) => {
  const {
    cabinetIdentifier,
    totalCount
  } = action.payload;
  if (!cabinetIdentifier || !state[cabinetIdentifier]) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      totalCount
    })
  });
};
const setAiErrorState = (state, action) => {
  const {
    cabinetIdentifier,
    error
  } = action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    [cabinetIdentifier]: _objectSpread(_objectSpread({}, state[cabinetIdentifier]), {}, {
      aiRequest: false,
      aiSuccess: false,
      aiError: error
    })
  });
};
const reducers = {
  [cabinetConstants.SET_CURRENT]: setCurrent,
  [cabinetConstants.INDEX]: reduceReducers(entityReducer.reducers[cabinetConstants.INDEX], index),
  [cabinetConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[cabinetConstants.INDEX_SUCCESS], indexSuccess),
  // CABINET_SAVE_SUCCESS is used when operations are performed on a cabinet, like bulk actions
  [cabinetConstants.SAVE_SUCCESS]: saveSuccess,
  // FORM_SAVE_SUCCESS is used when the form editor is used to create or modify a record
  [formConstants.SAVE_SUCCESS]: saveSuccess,
  [cabinetConstants.SELECT]: select,
  [cabinetConstants.SELECT_CLEAR]: selectClear,
  [cabinetConstants.SELECT_ALL]: selectAll,
  [cabinetConstants.SELECT_CLEAR_ALL]: selectClearAll,
  [cabinetConstants.SET_SELECTED_VIEW]: setSelectedView,
  [cabinetConstants.AI_REQUEST]: setAiRequest,
  [cabinetConstants.AI_SUCCESS]: setAiSuccess,
  [cabinetConstants.AI_ERROR]: setAiErrorState,
  [cabinetConstants.INDEX_COUNT_SUCCESS]: indexCountSuccess
};
export default applyReducer(reducers, initState);